<template>
  <div class="table-container">
    <table>
      <tr>
        <td><label for="reportDate">Report Date</label></td>
        <td><input id="reportDate" type="date" data-date-format="yyyy-mm-dd"
                   v-model="reportDate" placeholder="yyyy-mm-dd" /></td>
      </tr>
      <tr>
        <td><label for="dateOfBirth">Date of Birth</label></td>
        <td><input id="dateOfBirth" type="date"
                   data-date-format="yyyy-mm-dd" v-model="dob" placeholder="yyyy-mm-dd" @keypress="pressToProceed"/></td>
      </tr>
      <tr v-if="showNullInputWarning">
        <td class="warning" colspan="2">* Please fill in both dates</td>
      </tr>
      <tr v-if="showErrorDobWarning">
        <td class="warning" colspan="2">* Patient's date of birth must match with the record</td>
      </tr>
      <tr>
        <td><button @click="$emit('close')"  class="btn--close">Close</button></td>
        <td><button @click="continueSave">Continue</button></td>
      </tr>
    </table>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import 'date-input-polyfill';

  export default {
    name: "SaveModalInputs",
    data() {
      return {
        reportDate: '',
        dob: '',
        showNullInputWarning: false,
        showErrorDobWarning: false,
      }
    },
    computed: {
      ...mapGetters('login', {
        user: 'getUser',
      }),
    },
    methods: {
      continueSave() {
        this.showNullInputWarning = false;
        this.showErrorDobWarning = false;
        if (this.reportDate && this.dob) {
          if (this.dob !== this.user.dob) {
            this.showErrorDobWarning = true;
          }
          else {
            this.$emit('continueToSave', this.reportDate, this.dob);
          }
        }
        else {
          this.showNullInputWarning = true;
        }
      },
      pressToProceed(event) {
        if (event.keyCode === 13) {
          this.continueSave();
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  .table-container {
    background-color: #fff;
    position: absolute;
    top: 60px;
    left: 0;
    width: 96%;
    padding: 10px 20px;
    border-radius: 3px;
    -moz-box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2);
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2);
  }
  table {
    width: 100%;
  }
  label {
    font-size: 0.85em;
  }
  input[type=date] {
    font-size: 0.85em;
  }
  button {
    margin-top: 10px;
    border: none;
    border-radius: 3px;
    font-size: 0.8em;
    padding: 5px 10px;
    background-color: #2196F3;
    color: #fff;
    &:hover {
      background-color: #0060ff;
      cursor: pointer;
    }
  }

  .btn--close {
    background-color: #dc3545;
    &:hover {
      background-color: darken(#dc3545, 10%);
    }
  }

  .warning {
    color: tomato;
    font-size: 0.8em;
  }
</style>